<template>
  <div class="ficha-resumen" :class="{ 'hide-presencia': !mostrarPresencia }">
    <div class="titulo-variantes">
      {{ titulo }}
    </div>
    <div class="cantidad-variantes">
      <span class="main-kpi-cantidad">{{ cantidadVariantes }}</span>
      <span>Variantes</span>
    </div>
    <div class="presencia-variantes">
      <div class="padding-container">
        <span class="line1">Presente en</span>
        <span class="line2">{{ presencia }}</span>
        <span class="line3">Según el registro de muestras </span>
      </div>
    </div>
    <div class="distribucion-variantes">
      <div class="nota-cero-variates" v-if="cantidadVariantes === 0">
        <p>
          <strong>Nota: </strong>
          Actualmente, ninguna de las variantes muestreadas en el país corresponde a una variante
          {{ titulo2 }}.
        </p>
        <p>
          Con frecuencia se presentan cambios en el grupo de variantes de monitoreo ya que el
          conocimiento sobre el impacto de ciertas variantes en la salud de las personas aumenta
          constantemente.
        </p>
      </div>

      <BarrasPorcentaje
        v-if="labels.length > 0"
        :labels="labels"
        :counts="counts"
        :percents="percents"
        :colores="colores"
      />
    </div>
  </div>
</template>

<script>
import BarrasPorcentaje from "@/components/utils/BarrasPorcentaje";

export default {
  components: {
    BarrasPorcentaje,
  },
  props: {
    idVariante: {
      type: String,
      require: true,
    },
    titulo: {
      type: String,
      default: "Titlo Variante",
    },
    titulo2: {
      type: String,
      default: "de tipo (X)",
    },
    cantidadVariantes: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "green",
    },
    presencia: {
      type: String,
      default: "0 Municipios",
    },
    labels: Array,
    counts: Array,
    percents: Array,
    colores: Array,
    mostrarPresencia: {
      default: true,
      type: Boolean,
    },
  },
  mounted() {
    this.$el.style.setProperty("--main-color", this.color);
  },
};
</script>

<style lang="scss">
.ficha-resumen {
  --main-color: black;
  border: 1px solid var(--main-color);
  border-radius: 10px;
  //padding: 10px;
  margin: 10px 0;
  padding-bottom: 8px;
  display: grid;
  grid-template-areas:
    "title title"
    "cantidad presencia"
    "distribucion distribucion";
  grid-template-columns: 80px 1fr;
  grid-template-rows: auto 80px auto;

  &.hide-presencia {
    grid-template-areas:
      "title title"
      "cantidad cantidad"
      "distribucion distribucion";
    .presencia-variantes {
      display: none;
    }
  }

  .titulo-variantes {
    grid-area: title;
    background-color: var(--main-color);
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    text-align: center;
    font-size: 20px;
    line-height: 2;
    font-weight: 600;
    padding: 8px;
  }

  .cantidad-variantes {
    grid-area: cantidad;
    border-bottom: 1px solid var(--main-color);
    border-right: 1px solid var(--main-color);
    color: var(--main-color);
    text-align: center;
    font-size: 0.85rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (min-width: map-get($media-queries-limit, "mobile")) {
      border-right-width: 1px;
    }

    .main-kpi-cantidad {
      font-size: 3em;
      line-height: 1;
    }
  }

  .presencia-variantes {
    grid-area: presencia;
    border-bottom: 1px solid var(--main-color);
    color: var(--main-color);
    display: flex;
    font-size: 0.85rem;

    .padding-container {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto;
    }

    .line2 {
      font-size: 1.75em;
    }
    .line3 {
      font-size: 0.9em;
    }
  }
  .distribucion-variantes {
    grid-area: distribucion;
    color: var(--main-color);
    font-size: 0.85rem;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    .nota-cero-variates {
      font-size: 12px;
      padding: 10px 8px;
    }
  }
}
</style>
